import { AuthErrorCodes, getAuth, getRedirectResult } from 'firebase/auth'
import { FirebaseError } from 'firebase/app'

import { emitSystemNotification } from 'state/system_notification'

import { ATTESTATION_TOKEN_LOCAL_KEY } from './types'

/**
 * Continues the oauth2 process by calling {@link getRedirectResult}
 * remove the key @{@link ATTESTATION_TOKEN_LOCAL_KEY} from {@link window.localStorage}
 * when the user sign in/up successfully, since there isn't any point in storing it anymore
 */
export const signInWithOauth2Confirmation = async () => {
	const auth = getAuth()

	try {
		const result = await getRedirectResult(auth)

		if (!result) {
			return
		}

		// No point it storing this any further
		window.localStorage.removeItem(ATTESTATION_TOKEN_LOCAL_KEY)
	} catch (error) {
		console.error(error)

		if (error instanceof FirebaseError) {
			if (error.code === AuthErrorCodes.NEED_CONFIRMATION) {
				emitSystemNotification({
					display: 'dialog',
					variant: 'warning',
					title: 'Account Already Exists',
					message:
						'An account already exists with the same email address but was created using a different sign-in method. Please try signing in with the original method or use a different email address.'
				})
			} else {
				emitSystemNotification({
					display: 'dialog',
					variant: 'warning',
					title: 'Error',
					message:
						error.message ||
						error.toString() ||
						'Unknown error trying to confirm social media sign-in'
				})
			}
		}
	}
}
